import {
    AnnotationType,
    IQuestion,
    QuestionCategories,
    QuestionType,
} from "@sp-crm/core";
import { PrintViewSectionProps } from "./print-view-section";

export function renderQuestionSection(
    title: string,
    category: QuestionCategories,
    questions: IQuestion[],
): PrintViewSectionProps {
    return {
        title,
        fields: questions
            .filter(question => question.category === category)
            .map(question => {
                const fields = [];
                if (question.questionType === QuestionType.binary) {
                    fields.push({
                        label: question.title,
                        colSpan: 6,
                        type: "boolean" as const,
                    });
                }
                if (question.questionType === QuestionType.nary) {
                    fields.push({
                        label: question.title,
                        colSpan: 6,
                        type: "checkbox" as const,
                        options: question.prompts.map(prompt => prompt.title),
                    });
                }
                if (question.questionType === QuestionType.text) {
                    fields.push({
                        label: question.title,
                        colSpan: 12,
                    });
                }

                if (
                    question.questionType !== QuestionType.text &&
                    question.annotation === AnnotationType.single
                ) {
                    fields.push({
                        label: `${question.title} (notes)`,
                        colSpan: 6,
                    });
                }
                return fields;
            })
            .flat(),
        children: [],
    };
}
